import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import anchorme from 'anchorme';
import sanitizeHtml from 'sanitize-html';

@Injectable({
  providedIn: 'root',
})
export class ValidatorService {
  /**
   * The next 4 functions are used by agentScheduler
   * TODO: Refactor agentScheduler to use reactive form validators (the following "ValidatorFn" functions)
   *       then remove these boolean functions, they will be unused after refactoring agentScheduler
   */
  validateIsEmail(email: string): boolean {
    const regex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(email);
  }

  validateIsPhone(phone: string): boolean {
    const regex = /([().+ -]*[0-9]){10,11}[().+ -]*?/;
    return regex.test(phone);
  }

  validateIsTextString(string: string): boolean {
    const regex = /^\D+$/g;
    return regex.test(string);
  }

  validateComment(c: FormControl): ValidationErrors | null {
    let dirty: ('links' | 'email addresses' | 'HTML tags')[] = [];
    sanitizeHtml(c.value, {
      exclusiveFilter: function (frame) {
        if (frame.tag) {
          dirty.push('HTML tags');
        }
        return false;
      },
    });
    anchorme({
      input: c.value,
      options: {
        specialTransform: [
          {
            test: /[^]*/, //everything
            transform: (s) => {
              if (anchorme.validate.email(s)) {
                dirty.push('email addresses');
              } else {
                dirty.push('links');
              }
              return s;
            },
          },
        ],
      },
    });

    /**
     * build english representation of 'dirty' array
     */
    dirty = Array.from(new Set(dirty));
    const err: boolean = dirty.length > 0;
    let message = '';
    if (dirty.length === 1) {
      message += dirty[0];
    } else if (dirty.length > 1) {
      const anded: string = dirty.pop() + ' and ' + dirty.pop();
      if (dirty.length > 0) {
        dirty.push(anded as any);
        message += dirty.join(', ');
      } else {
        message += anded;
      }
    }
    message += ' are not allowed.';

    return !err
      ? null
      : {
          errorMessage: message,
        };
  }

  email(control: AbstractControl): ValidationErrors | null {
    const regex = /^[\w+.-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9]{2,63}$/;
    if (control.value && !regex.test(control.value) && control.value.length) {
      return { invalidFormat: true };
    }
    return null;
  }

  validateCommentFunction(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const dirty: ('links' | 'email addresses' | 'HTML tags')[] = [];
      sanitizeHtml(control.value, {
        exclusiveFilter: function (frame) {
          if (frame.tag) {
            dirty.push('HTML tags');
          }
          return false;
        },
      });
      anchorme({
        input: control.value,
        options: {
          specialTransform: [
            {
              test: /[^]*/, //everything
              transform: (s) => {
                if (anchorme.validate.email(s)) {
                  dirty.push('email addresses');
                } else {
                  dirty.push('links');
                }
                return s;
              },
            },
          ],
        },
      });

      if (!dirty) {
        return null;
      }
      if (dirty.length === 1) {
        return { errorMessage: dirty[0] + ' are not allowed.' };
      }
      if (dirty.length === 2) {
        return { errorMessage: dirty[0] + ' and ' + dirty[1] + ' are not allowed.' };
      }
      if (dirty.length === 3) {
        return { errorMessage: dirty[0] + ', ' + dirty[1] + ' and ' + dirty[2] + ' are not allowed.' };
      }
      return null;
    };
  }
}
